var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1009_63961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 350
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1009_63961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9167 306.25C64.8958 306.25 58.0295 303.394 52.3177 297.682C46.6059 291.97 43.75 285.104 43.75 277.083V72.9167C43.75 64.8958 46.6059 58.0295 52.3177 52.3177C58.0295 46.6059 64.8958 43.75 72.9167 43.75H277.083C285.104 43.75 291.97 46.6059 297.682 52.3177C303.394 58.0295 306.25 64.8958 306.25 72.9167V277.083C306.25 285.104 303.394 291.97 297.682 297.682C291.97 303.394 285.104 306.25 277.083 306.25H72.9167ZM72.9167 277.083H277.083V72.9167H72.9167V277.083ZM87.5 247.917H262.5L207.812 175L164.062 233.333L131.25 189.583L87.5 247.917Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePreview);
export default __webpack_public_path__ + "static/media/ImagePreview.3d6621b4c0f72aa7368c560d07a6e860.svg";
export { ForwardRef as ReactComponent };